import { Box, Checkbox, Dialog, DialogContent, InputAdornment, Stack, styled, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { farmers, region, userManagement } from "../../config/images";
import SearchIcon from "@mui/icons-material/Search";
import Pagination from "@mui/material/Pagination";
import { useNavigate } from "react-router-dom";
import translations from "../../config/language";
import { deleteRole, getRoleList } from "../../config/services";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

const RoleManagement = () => {
  const [addUserpopup, setAddUserPopup] = useState(false);
  const [editUserpopup, setEditUserPopup] = useState(false);
  const [deleteUserpopup, setDeleteUserPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [roleName, setRoleName] = useState("");
  const [editRoleName, setEditRoleName] = useState("");
  const [userId, setUserId] = useState("");
  const [deleteUserId, setDeleteUserId] = useState("");
  const [roleData, setRoleData] = useState([]);
  const [searchText, setSearchText] = useState();
  const [debounceSearchText, setDebouncedSearchText] = useState();

  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Role Management" && module.is_editor === true
  ) ? true : false;

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const language = process.env.REACT_APP_LANGUAGE;

  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));
  const navigate = useNavigate();

  const handleEditClick = (name, id) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setEditUserPopup(true);
    setEditRoleName(name);
    setUserId(id);
  };
  const handleDeleteClick = (id) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setDeleteUserPopup(true);
    setDeleteUserId(id)
  }
  const handleUpdateUser = (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (editRoleName == "") {
      notifyError(translations[language].roleNameRequired);
      return true;
    }
    navigate('/role-management-permission', {
      state: { roleId: userId, editRoleName: editRoleName },
    });
    setEditUserPopup(false);
  }
  const handleAddUser = (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (roleName == "") {
      notifyError(translations[language].roleNameRequired);
      return true;
    }
    navigate('/role-management-permission', {
      state: { isAdd: true, roleName: roleName }
    });
    setAddUserPopup(false);
  }
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText); // Update the debounced searchText
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Cleanup the timeout
    };
  }, [searchText]); // Effect runs when searchText changes
  const fetchRoleList = async () => {
    const data = {
      search: debounceSearchText,
    };
    try {
      const response = await getRoleList(data, currentPage, perPage);
      if (response.data.results.success == true) {
        setRoleData(response.data.results.payload);
        setCount(response.data.count);
      }


    } catch (error) {
      console.error('Error adding role:', error);
      notifyError(error.response.data.message);
    }
  }
  useEffect(() => {
    fetchRoleList();
  }, [currentPage, debounceSearchText]);
  const handleDeleteUser = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    const params = {
      role_id: deleteUserId,
    }
    try {
      const response = await deleteRole(params);
      if (response.data.success == true) {
        notifySuccess(response.data.message);
        setDeleteUserPopup(false);
        fetchRoleList();
      }
    } catch (error) {
      console.error('Error adding role:', error);
      notifyError(error.response.data.message);
      setDeleteUserPopup(false);
    }
  };
  return (
    <>
      <Box className="task-detail-box">
        <Box className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap" }}>
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img src={userManagement.userManagementIcon} alt="" />
            <Typography variant="h6" gutterBottom>
              {translations[language].roleManagement}
            </Typography>
          </Box>
          <Box className="pt-3 d-flex align-items-center assign-data-btn">
            <button
              className="assign-task-btn"
              style={{ height: "46px", marginLeft: "0px" }}
              onClick={() => {
                if (!isAccess) {
                  notifyError(translations[language].youDontHaveAccess);
                  return true;
                }
                setAddUserPopup(true)
              }
              }
            >
              {translations[language].addRole}
            </button>
          </Box>
        </Box>
        <Box className="mt-3 mb-4"
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "8px",
            overflow: "hidden",
            margin: "0px 20px",
            boxShadow: "0px 4px 10px rgba(151, 151, 151, 0.12)",
          }}
        >
          <TextField
            placeholder="Search here"
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                paddingRight: "0px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end"
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "400",
                    backgroundColor: "#31A05F",
                    height: "100%",
                    padding: "0px",
                    maxHeight: "unset",
                    padding: "0px 15px",
                  }}
                >
                  <SearchIcon sx={{ color: "#FFFFFF", mr: 1 }} />
                  Search
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box className="crop-table-container">
          <Table className="region-table pt-1" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "50px" }}>
                  <Checkbox
                    sx={{
                      color: "rgba(225, 230, 244, 1)",
                      borderRadius: "4px",
                      "&.Mui-checked": {
                        color: "rgba(199, 206, 227,1)",
                      },
                    }}
                  />
                </TableCell>
                <TableCell style={{ width: "100px" }}>{translations[language].srNo}</TableCell>
                <TableCell>{translations[language].userRole}</TableCell>
                <TableCell>{translations[language].permissions}</TableCell>
                <TableCell>{translations[language].actions}</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {roleData?.length > 0 ? roleData.map((e, i) => {
                const permissionModules = e.modules
                  ?.filter(module => !module.no_access)
                  ?.map(module => module.module_name)
                  ?.join(", ");

                return (
                  <TableRow>
                    <TableCell>
                      <Checkbox
                        sx={{
                          color: "rgba(225, 230, 244, 1)",
                          borderRadius: "4px",
                          "&.Mui-checked": {
                            color: "rgba(199, 206, 227,1)",
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}> {i + 1 + (currentPage - 1) * perPage}</TableCell>
                    <TableCell>{e.role_name}</TableCell>
                    <TableCell>{permissionModules}</TableCell>
                    <TableCell>
                      <div className="d-flex gap-3">
                        <img
                          src={region.editIcon}
                          alt=""
                          onClick={() => handleEditClick(e.role_name, e.id)}
                          style={{ cursor: "pointer", height: "23px" }}
                        />
                        <img
                          src={region.deleteIcon}
                          alt=""
                          onClick={() => handleDeleteClick(e.id)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                );
              }) : <TableRow>
                <TableCell colSpan={4} style={{ textAlign: "center" }}>
                  <img src={farmers.noData} alt="No Data" />
                </TableCell>
              </TableRow>}
            </TableBody>
          </Table>
        </Box>
        <Box display="flex" justifyContent="end" alignItems="center" className="pagination">
          <Stack spacing={2} className="mb-3">
            <CustomPagination
              count={Math.ceil(count / perPage)}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
            />
          </Stack>
        </Box>
        <Dialog
          open={addUserpopup}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                {translations[language].addRole}
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>
              <TextField
                fullWidth
                label="Enter User"
                name="roleName"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                className="mb-3"
              />
              <div className="d-flex gap-3 mt-2">
                <button
                  className="cancel-button"
                  onClick={(e) => {
                    e.preventDefault();
                    setAddUserPopup(false);
                  }}
                >
                  {translations[language].cancel}
                </button>
                <button
                  className="assign-task-button"
                  onClick={handleAddUser}
                >
                  {translations[language].addRole}
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={editUserpopup}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                {translations[language].editRole}
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>
              <TextField
                fullWidth
                label="Enter User"
                name="userName"
                value={editRoleName}
                onChange={(e) =>  setEditRoleName(e.target.value)}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button
                  className="cancel-button"
                  onClick={(e) => {
                    e.preventDefault();
                    setEditUserPopup(false);
                  }}
                >
                  {translations[language].cancel}
                </button>
                <button
                  className="assign-task-button"
                  onClick={handleUpdateUser}
                >
                  {translations[language].updateRole}
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={deleteUserpopup}
          maxWidth="xs"
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <DialogContent className="p-5" style={{ textAlign: "center" }}>
            <Box>
              <img src={region.correct} alt="" />
            </Box>
            <Typography variant="h5" className="pt-4 mb-2">
              <b>{translations[language].deleteRole} </b>
            </Typography>
            <Typography variant="p" className="pt-4" style={{ fontSize: "16px" }}> {translations[language].deleteRoleConfirmation} </Typography>
            <div className="d-flex gap-3 pt-4">
              <button
                className="assign-task-button"
                onClick={() => handleDeleteUser()}
              >
                Yes
              </button>
              <button
                className="assign-task-button"
                onClick={() => setDeleteUserPopup(false)}
              >
                No
              </button>
            </div>
          </DialogContent>
        </Dialog>
      </Box>
    </>
  );
};

export default RoleManagement;